import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavItemComponent } from './sidenav-item.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [SidenavItemComponent],
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatRippleModule,
        TranslateModule,

    ],
  exports: [SidenavItemComponent]
})
export class SidenavItemModule {
}
